import { useEffect } from "react"
import { useLocation } from "react-router-dom"

//doesn't work in SurveySection, because the navigation there is based on switching the state & not routing
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
